import request from "@/utils/request";

export function getDocType() {
  return request({
    url: `/documents/type/`,
    method: `get`,
  });
}

export function getDocTypeId(type, params) {
  return request({
    url: `/documents/type/${type}/`,
    method: `get`,
    params,
  });
}

export function putDocType(type, data) {
  return request({
    url: `/documents/type/`,
    method: `put`,
    data: typeof type === "string" ? data : type,
  });
}
